import { SET_FOOTER_STATE } from "./constants";
import produce from "immer";

// The initial state of this store.
const initialState = {
    data: {},
};

export default produce((state, action) => {
    switch (action.type) {
        case SET_FOOTER_STATE:
            state.data = action.footerState;
            break;
        default:
            break;
    }
}, initialState);
